import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Account/LogoutLink/logoutLink.container"
    ).then((module) => ({
        default: module.LogoutLinkContainer
    }))
);
